<template>
    <div id="logBox">
        <div
            v-for="log in logLines.slice().reverse()"
            :class="log.style"
            class="logLine"
            :key="log.id"
        >
        <span
          v-if="log.requestData || log.responseData"
          class="debug-icon"
          @click="openDebug(log)"
          title="View request &amp; response"
        >&#x1FAB2;</span>
        {{ log.text }}
        </div>
    </div>
    <CModal
      size="xl"
      :visible="showDebugModal"
      @close="showDebugModal = false"
    >
      <CModalHeader>
        <CModalTitle>5G Charging Request / Response</CModalTitle>
      </CModalHeader>
      <CModalBody class="debug-modal-body">
        <div class="json-section">
          <div class="json-section-header">
            <span class="json-label">Request</span>
            <span class="copy-btn" @click="copyToClipboard(debugLog.requestData)" title="Copy to clipboard">
              <font-awesome-icon icon="fa-regular fa-copy" />
              <span v-if="copiedSection === 'request'" class="copied-text">Copied!</span>
            </span>
          </div>
          <div class="json-block">
            <JsonTree :data="debugLog.requestData" />
          </div>
        </div>
        <div class="json-section">
          <div class="json-section-header">
            <span class="json-label">Response</span>
            <span class="copy-btn" @click="copyToClipboard(debugLog.responseData, 'response')" title="Copy to clipboard">
              <font-awesome-icon icon="fa-regular fa-copy" />
              <span v-if="copiedSection === 'response'" class="copied-text">Copied!</span>
            </span>
          </div>
          <div class="json-block">
            <JsonTree :data="debugLog.responseData" />
          </div>
        </div>
      </CModalBody>
    </CModal>
</template>

<script>
import JsonTree from './JsonTree.vue'

export default {
  components: { JsonTree },
  props: {
    logLines: Array
  },
  data () {
    return {
      showDebugModal: false,
      debugLog: {},
      copiedSection: null
    }
  },
  methods: {
    openDebug (log) {
      this.debugLog = log
      this.copiedSection = null
      this.showDebugModal = true
    },
    async copyToClipboard (data, section) {
      if (!data) return
      try {
        await navigator.clipboard.writeText(JSON.stringify(data, null, 2))
        this.copiedSection = section || 'request'
        setTimeout(() => { this.copiedSection = null }, 1500)
      } catch {
        // fallback ignored
      }
    }
  }
}
</script>

<style scoped>
.logLine{
    white-space: pre-wrap;
    margin-left: 1rem;
    margin-top: .25rem;
    text-align: left;
    color: #d4d4d4;
    font-family: 'Source Code Pro', monospace;
    font-size: 20px;
}
#logBox {
    padding: 10px;
    background-color: #1e1e1e;
    min-height: 100% !important;
}
.info{
    color: #6699CC;
}
.error{
    color: #EC5f67;
}
.notification{
    color: #FAC863;
}
.quota-success{
    color: #98fa63;
    font-size: 15px;
}
.quota-success-partial{
    color: #ffb700;
    font-size: 15px;
}
.quota-fail{
    color: #ff000d;
    font-size: 15px;
}
.debug-icon{
    cursor: pointer;
    margin-right: 4px;
    font-size: 14px;
    opacity: 0.7;
    transition: opacity 0.15s;
}
.debug-icon:hover{
    opacity: 1;
}
.debug-modal-body{
    max-height: 75vh;
    overflow-y: auto;
    padding: 16px 24px;
}
.json-section{
    margin-bottom: 16px;
}
.json-section-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}
.json-label{
    font-weight: 600;
    font-size: 13px;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.copy-btn{
    cursor: pointer;
    color: #666;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: color 0.15s;
}
.copy-btn:hover{
    color: #333;
}
.copied-text{
    font-size: 11px;
    color: #28a745;
    font-weight: 500;
}
.json-block{
    background: #f3f3f3;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px 14px;
    max-height: 35vh;
    overflow: auto;
}
</style>
